export function detectSignificantSizeChange(
    div,
    callbackOnChangeDetected,
    changeSizeInPixel = 5,
    minimumTimeInMS = 300,
) {
    // Detects when the div changes size and calls the callbackOnChangeDetected function.
    // Changes of less than changeSizeInPixel pixels or shorter than minimumTimeInMS milliseconds are ignored
    let lastWidth = div.offsetWidth;
    let lastHeight = div.offsetHeight;

    let timeoutId = null;
    function lookForChanges() {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            if (
                Math.abs(div.offsetWidth - lastWidth) > changeSizeInPixel ||
                Math.abs(div.offsetHeight - lastHeight) > changeSizeInPixel
            ) {
                lastWidth = div.offsetWidth;
                lastHeight = div.offsetHeight;
                callbackOnChangeDetected();
            }
        }, minimumTimeInMS);
    }
    if('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(lookForChanges);
        resizeObserver.observe(div);
        return () => {
            resizeObserver.unobserve(div);
        };
    }else{
        // Fallback on window resize for old ios mostly
        window.addEventListener('resize', lookForChanges);
        return () => {
            window.removeEventListener('resize', lookForChanges);
        };
    }
}
